import { useContext } from 'react';
import { AppointmentTimePreferenceContext } from './AppointmentTimePreferenceContext';

export function useAppointmentTimePreference() {
  const context = useContext(AppointmentTimePreferenceContext);

  if (context === undefined) {
    throw new Error(
      'useAppointmentTimePreference must be used within a AppointmentTimePreferenceProvider',
    );
  }

  return context;
}
